import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import { IoBagHandleOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { addToCart } from "../../api/cartApi";
import { useParams } from "react-router-dom";
import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const ProductView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { productId } = location.state || {}; // ✅ received from navigate(..., { state: { productId } })
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);


  
 useEffect(() => {
    // First, try to use product from state
    if (location.state?.product) {
      console.log("Using product from state:", location.state.product);
      setProduct(location.state.product);
            setMainImage(location.state.product.product_media?.[0]?.url || "");

      setLoading(false);
      return;
    }

    // If no state, fetch from API
    const fetchProduct = async () => {
      try {
        setLoading(true);
        setError(null);
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

        if (!token) {
          setError("Authentication required");
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/product?id=${id}`,
          {
            headers: {
              token,
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data.success) {
          console.log("Fetched product from API:", response.data.result);
          setProduct(response.data.result);
        } else {
          setError('Failed to fetch product');
        }
      } catch (err) {
        console.error('Error fetching product:', err);
        setError(err.message || 'Error fetching product');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id, location.state]);


  if (loading)
    return <div className="p-6 text-gray-600">Loading product details...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!product)
    return <div className="p-6 text-gray-600">No product found.</div>;

  const handleBuyNow = async () => {
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      if (!token) {
        alert("Please log in to continue.");
        return;
      }

      const response = await addToCart(product.id); // ✅ existing API call
      if (response?.success) {
        navigate("/cart"); // ✅ redirect to cart page after success
      } else {
        alert(response?.message || "Failed to add to cart.");
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
      alert("Something went wrong while adding to cart.");
    }
  };

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />
      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />

        <div className="mb-6">
          <button
            className="text-sm  text-[#095228] font-semibold"
            onClick={() => navigate(-1)}
          >
            ← BACK
          </button>
        </div>

        {/* Product Details Section */}
        <div className="flex flex-col md:flex-row bg-white p-6">
          {/* Left: Product Images */}
          <div className="flex flex-col items-center md:w-1/2">
           {product.product_media?.[0]?.url ? (
            <img
              src={product.product_media[0].url}
              alt={product.product_name}
              className="w-full rounded-lg"
            />
          ) : (
            <div className="w-full h-96 bg-gray-200 rounded-lg flex items-center justify-center">
              No image available
            </div>
          )}
            <div className="flex space-x-3 overflow-x-auto">
              {product.product_media?.map((img, idx) => (
                <img
                  key={idx}
                  src={img.url}
                  alt={`thumb-${idx}`}
                  className={`w-20 h-14 object-contain rounded-lg cursor-pointer border ${
                    mainImage === img.url
                      ? "border-green-600"
                      : "border-gray-200"
                  }`}
                  onClick={() => setMainImage(img.url)}
                />
              ))}
            </div>
          </div>

          {/* Right: Product Details */}
          <div className="md:w-1/2 md:pl-12 flex flex-col justify-between">
            <div>
              <div className="text-md mb-2 font-bold italic  leading-[100%] tracking-[0] ">
                {product.category?.title || "Category"}{" "}
                <span className="mx-2">{`→`}</span>{" "}
                {product.subcategory?.title || "Subcategory"}
              </div>
              <div className="flex gap-2 items-center">
                <p className="text-green-700 font-bold uppercase">
                  {product.brand_name || "Brand"}
                </p>
                <p className="border-l-2 border-gray-500 w-[10px] h-[20px]"></p>
                <div className="flex border-2 gap-2 p-1 rounded-xl text-[12px] items-center">
                  Sold By:{" "}
                  <div className="bg-white  ">
                    <img
                      src="/image/wanchain.png"
                      alt="logo"
                      className="w-[20px] h-[20px] object-contain"
                    />
                  </div>
                  <div className="text-black">
                    <p className="text-xs text-black font-semibold ">
                      {product.seller?.name || "Seller"}
                    </p>{" "}
                  </div>
                </div>
              </div>

              <h1 className="text-2xl font-bold mb-2">
                {product.product_name}
              </h1>

              <div className="flex items-center gap-10  mb-1">
                <div>
                  <p className="font-medium italic text-[12px] leading-[100%] tracking-[0]">
                    Product Price
                  </p>
                  <span className="text-gray-400 line-through text-lg mr-2">
                    ${product.product_price}
                  </span>
                </div>
                <div>
                  <p className="font-medium italic text-[12px] leading-[100%] tracking-[0]">
                    Product Price
                  </p>
                  <span className="text-xl font-semibold text-green-700">
                    ${product.discount_price}
                  </span>
                </div>
                <div>
                  {product.offer_percentage && (
                    <div>
                      <p className="font-medium italic text-[12px] leading-[100%] tracking-[0]">
                        Product Price
                      </p>

                      <span className=" text-green-700 font-bold">
                        {product.offer_percentage}% OFF
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <p className="mb-6 text-gray-700">
                {product.description || "No product description available."}
              </p>
            </div>

            {/* Quantity & Buy Now */}
            <div className="flex items-center mt-4">
              <button
                className="w-8 h-8 border rounded-full"
                onClick={() => setQuantity((q) => Math.max(1, q - 1))}
              >
                -
              </button>
              <span className="px-4">
                {quantity < 10 ? `0${quantity}` : quantity}
              </span>
              <button
                className="w-8 h-8 border rounded-full"
                onClick={() => setQuantity((q) => q + 1)}
              >
                +
              </button>
              <button
                onClick={handleBuyNow}
                className="ml-4 flex gap-2 items-center bg-black text-white rounded-full px-8 py-3 font-semibold hover:bg-green-800 transition"
              >
                <IoBagHandleOutline className="text-lg" /> <span>BUY NOW</span>
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProductView;
